<mat-accordion>
  <mat-expansion-panel
    *ngFor="let panel of accordionData; let i = index"
    (opened)="onPanelExpand(i)"
  >
    <mat-expansion-panel-header [ngStyle]="panel.headerStyle">
      <mat-panel-title [ngStyle]="panel.titleStyle">
        {{ panel.title ? panel.title : "" }}
      </mat-panel-title>
    </mat-expansion-panel-header>

    <div class="mt-2">
      <ng-container #dynamicContent></ng-container>
    </div>
  </mat-expansion-panel>
</mat-accordion>
